import React from "react";
import WhiteButton from "../../../../Components/WhiteButton";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CareersJoinUsSection = () => {
  const navigate = useNavigate();
  return (
    <div className="relative w-full my-[24%] md:my-[6%] overflow-hidden">
      {/* Text Content */}
      <div className="relative z-20 flex flex-col justify-center items-center h-full text-center px-4 md:px-20 md:py-36 space-y-12">
        <p className="text-2xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg leading-normal tracking-wide">
          We are a powerhouse of 20+ AI researchers, data scientists, engineers,
          and designers—bringing 100+ years of combined expertise from industry
          giants like Walmart, McKinsey, Sequoia, Adobe, DataRobot, Ericsson,
          Target, and E&Y.
        </p>
        <WhiteButton
          text="Join Our Team"
          icon={<ArrowRight />}
          onClick={() => navigate("/careers")}
        />
      </div>
    </div>
  );
};

export default CareersJoinUsSection;
